import { Logo } from "@/components/sidebar/logo";
import { NewChat } from "@/components/sidebar/newchat";
import { ChatList } from "@/components/sidebar/chatlist";
import { User } from "@/components/sidebar/user";
import { SidebarProps } from "@/lib/types";
import { X } from "@phosphor-icons/react";
import React from "react";
import { AuthenticatedTemplate } from "@azure/msal-react";

export const Sidebar = ({ sidebar }: SidebarProps) => {
    return (
        <div
            className={`relative flex-none w-full ${sidebar.sidebarOpen ? "block" : "hidden"} lg:block lg:w-auto lg:basis-64 lg:max-w-64 h-svh bg-gradient-to-br from-zinc-100 to-zinc-200`}
        >
            <div
                className={
                    "absolute top-0 left-0 w-full h-full z-0 opacity-5 bg-[url('/leftbg.png')] bg-cover"
                }
            >
                &nbsp;
            </div>
            <div className={"relative flex z-10 h-full flex-col"}>
                <div className={"lg:hidden pt-4 px-2 flex flex-row justify-start items-start"}>
                    <div onClick={() => sidebar.setSidebarOpen(false)}>
                        <X size={24} className={"text-zinc-700"} />
                    </div>
                </div>
                <Logo />
                <AuthenticatedTemplate>
                    <NewChat sidebar={sidebar} />
                    <ChatList sidebar={sidebar} />
                    <User />
                </AuthenticatedTemplate>
            </div>
        </div>
    );
};
